<template>
  <div>
    <div ref="lightbox" />
  </div>
</template>

<script>
export default {
  components: {},

  props: {
    images: {
      type: Array,
      required: true,
    },
  },

  methods: {
    show(index = 0) {
      window.lightGallery(this.$refs.lightbox, {
        dynamic: true,
        dynamicEl: this.images.map((image) => ({
          src: image,
        })),
        loop: true,
        width: '1100px',
        height: '750px',
        mode: 'lg-fade',
        addClass: 'lightbox-fixed-size',
        counter: false,
        download: false,
        startClass: '',
        thumbnail: true,
        index,
      })

      setTimeout(() => {
        window.lgData[this.$refs.lightbox.getAttribute('lg-uid')].slide(index)
      }, 0)
    },
  },
}
</script>

<style lang="scss">
.lg-backdrop {
  background-color: rgba(0, 0, 0, 0.4);
}

.lightbox-fixed-size {
  .lg {
    @apply bg-white;
  }

  .lg-inner {
    @apply flex items-center justify-center whitespace-normal;
  }

  .lg-item {
    max-width: 1000px;
    max-height: 80%;
  }

  .lg-toolbar {
    @apply bg-transparent;
  }

  .lg-sub-html {
    @apply absolute pin-b bg-transparent text-sm pt-8;
    transform: translateY(100%);
  }

  .lg-close {
    margin-top: 2rem;
    margin-right: 2rem;
    display: block;
    height: 1.5rem;
    width: 1.5rem;

    &:hover::after {
      background-image: url("data:image/svg+xml,%3Csvg fill='%23F5000D' width='24' height='24' viewBox='0 0 24 24' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M12 7.841L19.841 0 24 4.159 16.159 12 24 19.841 19.841 24 12 16.159 4.159 24 0 19.841 7.841 12 0 4.159 4.159 0 12 7.841z' fill-rule='nonzero'/%3E%3C/svg%3E");
    }

    &::after {
      content: '';
      display: block;
      height: 1.5rem;
      width: 1.5rem;
      background-position: center;
      background-repeat: no-repeat;
      background-image: url("data:image/svg+xml,%3Csvg fill='%233C5174' width='24' height='24' viewBox='0 0 24 24' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M12 7.841L19.841 0 24 4.159 16.159 12 24 19.841 19.841 24 12 16.159 4.159 24 0 19.841 7.841 12 0 4.159 4.159 0 12 7.841z' fill-rule='nonzero'/%3E%3C/svg%3E");
    }
  }

  .lg-next {
    @apply bg-transparent;

    &:hover::before {
      background-image: url("data:image/svg+xml,%3Csvg width='16' height='26' viewBox='0 0 16 26' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M0 21.842l3.297-3.32 3.297-3.32 2.356-2.534-2.356-2.498-3.297-3.32L0 3.53l1.753-1.765L3.505 0l6.248 6.29C13.189 9.75 16 12.628 16 12.686c0 .092-12.405 12.65-12.496 12.65-.019 0-.815-.785-1.77-1.747L0 21.842z' fill='%23F5000D' fill-rule='nonzero'/%3E%3C/svg%3E");
    }

    &::before {
      content: '';
      @apply block h-6 w-6 bg-center bg-no-repeat;
      background-image: url("data:image/svg+xml,%3Csvg width='16' height='26' viewBox='0 0 16 26' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M0 21.842l3.297-3.32 3.297-3.32 2.356-2.534-2.356-2.498-3.297-3.32L0 3.53l1.753-1.765L3.505 0l6.248 6.29C13.189 9.75 16 12.628 16 12.686c0 .092-12.405 12.65-12.496 12.65-.019 0-.815-.785-1.77-1.747L0 21.842z' fill='%233C5174' fill-rule='nonzero'/%3E%3C/svg%3E");
    }
  }

  .lg-prev {
    @apply bg-transparent;

    &:hover::after {
      background-image: url("data:image/svg+xml,%3Csvg width='16' height='26' viewBox='0 0 16 26' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M16 21.842l-3.297-3.32-3.297-3.32-2.356-2.534 2.356-2.498 3.297-3.32L16 3.53l-1.753-1.765L12.495 0 6.247 6.29C2.811 9.75 0 12.628 0 12.686c0 .092 12.405 12.65 12.496 12.65.019 0 .815-.785 1.77-1.747L16 21.842z' fill='%23F5000D' fill-rule='nonzero'/%3E%3C/svg%3E");
    }

    &::after {
      content: '';
      @apply block h-6 w-6 bg-center bg-no-repeat;
      background-image: url("data:image/svg+xml,%3Csvg width='16' height='26' viewBox='0 0 16 26' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M16 21.842l-3.297-3.32-3.297-3.32-2.356-2.534 2.356-2.498 3.297-3.32L16 3.53l-1.753-1.765L12.495 0 6.247 6.29C2.811 9.75 0 12.628 0 12.686c0 .092 12.405 12.65 12.496 12.65.019 0 .815-.785 1.77-1.747L16 21.842z' fill='%233C5174' fill-rule='nonzero'/%3E%3C/svg%3E");
    }
  }

  .lg-img-wrap {
    position: relative;
  }

  .lg-outer .lg-img-wrap {
    height: auto;
  }
}

.lg-outer.lg-css3 .lg-item.lg-prev-slide {
  transition: transform 0.6s cubic-bezier(0, 0, 0.25, 1) 0s, opacity 0s 0.6s !important;
}

.lg-css3.lg-slide.lg-use-css3 .lg-item.lg-current {
  transition: transform 0.6s cubic-bezier(0, 0, 0.25, 1) 0s, opacity 0s 0s !important;
}
</style>
